module.exports = __webpack_public_path__ + "static/banner-desktop-03-68219dc42b8ca0f905d411c2fc3c0366.jpg";